import { DateTime } from "luxon";
export function getMonthSpan(startDate, endDate, endInclusive = false) {
    if (!startDate || !endDate)
        return undefined;
    const start = typeof startDate === "string" ? DateTime.fromISO(startDate) : startDate;
    const end = typeof endDate === "string" ? DateTime.fromISO(endDate) : endDate;
    if (!start.isValid || !end.isValid) {
        return undefined;
    }
    if (start >= end) {
        return undefined;
    }
    const span = Math.floor(end
        .minus({ days: endInclusive ? 0 : 1 })
        .diff(start, ["months", "millisecond"]).months) + 1;
    return span;
}
export function isKeyOf(obj, key) {
    return key in obj;
}
export function asHdnType(key, hdnType) {
    if (!key || !hdnType) {
        return undefined;
    }
    if (isKeyOf(hdnType, key)) {
        return key;
    }
    const keyStr = key;
    const code = keyStr.split(" ")[0];
    if (code) {
        for (const hdnKey of Object.keys(hdnType)) {
            if (hdnKey.startsWith(`${code} `)) {
                return hdnKey;
            }
        }
    }
    return undefined;
}
